import { createContext, useContext, useState, useCallback } from "react";
import { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

const MOCK_ADMIN = { id: 1, email: "admin@fullstackendeavours.in", name: "Admin" };
const MOCK_PASSWORD = "admin123";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("fe-user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading] = useState(false);

  const login = useCallback(async (email, password) => {
    await new Promise((res) => setTimeout(res, 400));
    if (email === MOCK_ADMIN.email && password === MOCK_PASSWORD) {
      localStorage.setItem("fe-user", JSON.stringify(MOCK_ADMIN));
      setUser(MOCK_ADMIN);
      return MOCK_ADMIN;
    }
    const err = new Error("Invalid credentials");
    err.response = { data: { detail: "Invalid email or password." } };
    throw err;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("fe-user");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
